'use strict';

module.exports = '0.0.0-6ac260d';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-core/node_modules/algoliasearch-helper/src/version.js
// module id = 62
// module chunks = 0